// extracted by mini-css-extract-plugin
module.exports = {"custom-datepicker":"dateStyle_custom-datepicker__1_plm","dateLangDiv":"dateStyle_dateLangDiv__3i5sn","localDate":"dateStyle_localDate__rxuC6"};